import { defineComponent as _defineComponent } from 'vue'
import {
  computed, nextTick, ref, toRefs
} from 'vue';
import BCXPeopleIcon from '@/components/molecules/BCXPeopleIcon.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import { useMediaQuery, whenever } from '@vueuse/core';
import LPBgArrow from './LPBgArrow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LPAccordionItem',
  props: {
  title: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: false,
    default: undefined
  },
  isOpen: {
    type: Boolean,
    required: false,
    default: false
  },
  headlineWidth: {
    type: Number,
    required: false,
    default: 0
  }
},
  emits: ['open-item', 'close-item'],
  setup(__props, { emit }) {

const props = __props;




const {
  title, text, icon, isOpen
} = toRefs(props);
const isMobile = useMediaQuery('(width < 800px)');
const accordionItemHeadline = ref<HTMLElement | null>(null);

const accordionItemText = ref<InstanceType<typeof BCXMarkdown> | null>(null);
const accordionItemTextHeight = computed(() => accordionItemText.value?.$el.scrollHeight ?? 200);

const openItem = () => {
  emit('open-item');
};

const closeItem = () => {
  emit('close-item');
};

whenever(isOpen, () => {
  const { scrollY } = window;
  const vh = Math.max((document.documentElement.clientHeight ?? 0), (window.innerHeight ?? 0));
  const accordionItemPosition = accordionItemHeadline.value?.getBoundingClientRect().top ?? 0;

  if (isMobile.value && accordionItemPosition > vh / 2) {
    nextTick(() => {
      setTimeout(() => {
        window.scrollTo({ top: (accordionItemHeadline.value?.offsetTop ?? 0) - 50, behavior: 'smooth' });
      }, 500);
    });
  } else {
    window.scrollTo({ top: scrollY, behavior: 'smooth' });
  }
});


return { __sfc: true,props, emit, title, text, icon, isOpen, isMobile, accordionItemHeadline, accordionItemText, accordionItemTextHeight, openItem, closeItem, BCXPeopleIcon, BCXMarkdown, LPBgArrow }
}

})